import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { YOUTUBE_CONFIG } from '../config/constants';
import "../style.css";

function DailyRecommendation({ setVideoState }) {
  const [dailyVideo, setDailyVideo] = useState(null);

  useEffect(() => {
    const fetchDailyVideo = async () => {
      const today = new Date().toISOString().split("T")[0]; // Get today's date (YYYY-MM-DD)
      const playlistId = YOUTUBE_CONFIG.DEFAULT_PLAYLIST_ID;
      const apiKey = "AIzaSyCX5Cc3TE-Te-W7N27uPxhUFh3RY3ZIfnc";
      const url = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId=${playlistId}&key=${apiKey}`;

      try {
        const response = await fetch(url);
        const data = await response.json();

        if (data.items && data.items.length > 0) {
          const dayIndex = new Date(today).getDate() % data.items.length;
          const video = data.items[dayIndex];
          const videoData = {
            id: video.snippet.resourceId.videoId,
            title: video.snippet.title,
            thumbnail: video.snippet.thumbnails.medium.url,
          };

          setDailyVideo(videoData);
        }
      } catch (error) {
        console.error("Error fetching daily video:", error);
      }
    };

    fetchDailyVideo();
  }, []);

  const handleClick = () => {
    if (dailyVideo) {
      setVideoState((prev) => ({
        ...prev,
        url: `https://www.youtube.com/watch?v=${dailyVideo.id}`,
        id: dailyVideo.id,
      }));
    }
  };

  if (!dailyVideo) {
    return <p>Loading daily recommendation...</p>;
  }

  return (
    <section className="daily-recommendation-container">
      <div>
        <h3 className="daily-recommendation-title">Daily Recommendation</h3>
      </div>

      <div className="daily-recommendation" onClick={handleClick} title={dailyVideo.title}>
        <img
          src={dailyVideo.thumbnail}
          alt={dailyVideo.title}
          className="daily-thumbnail"
        />
        <p className="daily-title">
          {dailyVideo.title.length > 20
            ? `${dailyVideo.title.substring(0, 15)}...`
            : dailyVideo.title}
        </p>
      </div>
    </section>
  );
}

DailyRecommendation.propTypes = {
  setVideoState: PropTypes.func.isRequired
};

export default DailyRecommendation;